import { apiClient } from '@services/api-client'
import { SNA_PREFIX } from '@services/utils'
import { useQuery } from '@tanstack/react-query'
import type { OfferDetail } from 'types/api'

export const offersQueryKey = ['offers-detail']

export function useOffersDetail(id?: string) {
  async function getOffersDetail() {
    const response = await apiClient.get<OfferDetail>(
      `${SNA_PREFIX}offers/${id}/`
    )

    return response.data
  }

  return useQuery({
    queryFn: getOffersDetail,
    queryKey: [...offersQueryKey, id]
  })
}
